import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const institutionTypeApi = generateNomenApi(`/nomen/institution-type`);

export const institutionTypeOptions = generateNomenOptions('institution-type', institutionTypeApi);
